import { wms } from './wms';
import { wmts } from './wmts';

const ows = async (url) => {
    const wms_data = await wms(url);
    const wmts_data = await wmts(url);

	return {
        wms: wms_data,
        wmts: wmts_data
    }
}

export {
	ows
}